module.exports = __webpack_public_path__ + "img/logo_aviodPhoney.27c8aa74.png";